import { ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { FilledExclamationMark } from '../../../common/svgIcons';

interface MainTradeFormErrorBoxProps {
  message: ReactNode;
}

export const wrapperElementStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 'extra_small_3',
  fontSize: 'caption.small_light',
  fontWeight: 'caption.small_light',
  letterSpacing: 'caption.small_light',
  lineHeight: 'caption.medium_medium',
};

const errorBoxStyles = {
  ...wrapperElementStyles,
  color: 'warning.text_primary',
};

const MainTradeFormErrorBox = ({ message }: MainTradeFormErrorBoxProps) => {
  return (
    <div
      className={css(errorBoxStyles)}
      data-testid="special-input-field__error"
      data-element="error"
      role="alert"
    >
      <FilledExclamationMark
        size={16}
        color="warning.text_primary"
        aria-hidden="true"
      />

      <span>{message}</span>
    </div>
  );
};

export { MainTradeFormErrorBox };
